import PhotoCameraOutlined from '@mui/icons-material/PhotoCameraOutlined';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import RuleOutlined from '@mui/icons-material/RuleOutlined';
import ScienceOutlined from '@mui/icons-material/ScienceOutlined';
import { useTranslation } from 'react-i18next';
import { IntroCard, type IntroCardStep } from '../../../../components/intro-card';

interface AddItemIntroCardProps {
  defaultExpanded?: boolean;
}

export function AddItemIntroCard({ defaultExpanded = false }: AddItemIntroCardProps) {
  const { t } = useTranslation('goodsReceiving');

  const steps: IntroCardStep[] = [
    {
      icon: <PhotoCameraOutlined />,
      title: t('addItemIntro.step1Title'),
      description: t('addItemIntro.step1Desc'),
    },
    {
      icon: <RuleOutlined />,
      title: t('addItemIntro.step2Title'),
      description: t('addItemIntro.step2Desc'),
    },
    {
      icon: <ScienceOutlined />,
      title: t('addItemIntro.step3Title'),
      description: t('addItemIntro.step3Desc'),
    },
    {
      icon: <ReportProblemOutlined />,
      title: t('addItemIntro.step4Title'),
      description: t('addItemIntro.step4Desc'),
    },
  ];

  return (
    <IntroCard
      eyebrow={t('addItemIntro.eyebrow')}
      collapsedHint={t('addItemIntro.collapsedHint')}
      headline={t('addItemIntro.headline')}
      ariaLabel={t('addItemIntro.ariaLabel')}
      steps={steps}
      defaultExpanded={defaultExpanded}
    />
  );
}
